import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/main.scss';
import App from './App';


if (process.env.NODE_ENV === 'production') {

  const noop = () => {};
  Object.keys(console).forEach(key => {
    if (typeof console[key] === 'function') {
      console[key] = noop;
    }
  });
  

  window.console = {
    ...console,
    log: noop,
    warn: noop,
    error: noop,
    info: noop,
    debug: noop,
    trace: noop,
    table: noop,
    group: noop,
    groupEnd: noop,
    groupCollapsed: noop,
    time: noop,
    timeEnd: noop,
    count: noop,
    countReset: noop,
    clear: noop,
    assert: noop,
    dir: noop,
    dirxml: noop,
    profile: noop,
    profileEnd: noop,
    timeStamp: noop,
    timeline: noop,
    timelineEnd: noop
  } as unknown as Console;


  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    return false;
  });


  document.addEventListener('keydown', (e) => {

    if (e.key === 'F12') {
      e.preventDefault();
      return false;
    }
    

    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault();
      return false;
    }
    

    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault();
      return false;
    }
    

    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault();
      return false;
    }
    

    if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      e.preventDefault();
      return false;
    }
    

    if (e.ctrlKey && e.shiftKey && e.key === 'K') {
      e.preventDefault();
      return false;
    }
    

    if (e.ctrlKey && e.shiftKey && e.key === 'E') {
      e.preventDefault();
      return false;
    }
  });


  document.addEventListener('selectstart', (e) => {
    e.preventDefault();
    return false;
  });


  document.addEventListener('dragstart', (e) => {
    e.preventDefault();
    return false;
  });


  let devtools = { open: false, orientation: null };
  const threshold = 160;
  
  setInterval(() => {
    if (window.outerHeight - window.innerHeight > threshold || 
        window.outerWidth - window.innerWidth > threshold) {
      if (!devtools.open) {
        devtools.open = true;


      }
    } else {
      devtools.open = false;
    }
  }, 500);


  Object.defineProperty(window, 'devtools', {
    get: () => ({ open: false, orientation: null }),
    set: () => {}
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 